import type { AutoHealConfig, TestStepMode } from '@prisma/client';

// How many cycles the AI agent can run before it fails
export const DEFAULT_AGENT_CYCLE_COUNT = 70;
export const MAX_AGENT_CYCLE_COUNT = 300;
// How many deviations the auto-heal AI can do before it fails
export const DEFAULT_AUTO_HEAL_CYCLE_COUNT = 6;
export const MAX_AUTO_HEAL_CYCLE_COUNT = 20;

export const AUTO_HEAL_CONFIG_OPTIONS = [
  { label: 'Locator only', value: 'LOCATOR_ONLY' satisfies AutoHealConfig },
  { label: 'Minor UI changes', value: 'UI' satisfies AutoHealConfig },
  { label: 'User flow changes', value: 'USER_FLOW' satisfies AutoHealConfig },
];

export const AUTO_HEAL_EXPLANATIONS: Record<AutoHealConfig, string> = {
  LOCATOR_ONLY: 'Only heals broken locators',
  UI: 'Heals minor changes to UI elements, such as position or text changes',
  USER_FLOW: 'Heals broken user flows, potentially adding new steps to fix the flow',
};

export const STEP_MODES = [
  {
    label: 'Strict',
    value: 'STRICT' satisfies TestStepMode,
    explanation: 'Executes the recorded steps exactly as they were captured, without any adaptability.',
  },
  {
    label: 'Auto-heal',
    value: 'AI_FALLBACK' satisfies TestStepMode,
    explanation: 'Uses recorded actions by default, but can automatically adjust for minor UI changes.',
  },
] as const;
